module.exports = __webpack_public_path__ + "static/media/10UNOHRLLS3.8ba9ef5b.jpg";